import { Component, OnInit, ElementRef, ViewChild, Input, Self, Output, EventEmitter, SimpleChanges, OnChanges, AfterViewChecked } from '@angular/core';
import { NgControl, Validators, AbstractControl } from '@angular/forms';
import { StoreLocationsService } from 'src/app/services/store-locations.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'select-field-locations',
  templateUrl: './select-field-locations.component.html',
  styleUrls: ['./select-field-locations.component.scss']
})
export class SelectFieldLocationsComponent implements OnInit, OnChanges, AfterViewChecked {

  @ViewChild('select', {static: true}) select: ElementRef;

  // inputs
  @Input() label: string = 'Locations';
  @Input() defaultOptionText: string = null;
  @Input() disableIfNoStoreId: boolean = false;
  @Input() required: boolean = false;
  @Input() fieldError: string;
  @Input() isSubmitted: boolean = false;
  @Input() storeRefId: any;

  @Output() ready: EventEmitter<any> = new EventEmitter();
  @Output() selected: EventEmitter<any> = new EventEmitter();

  // options data
  options: any[] = [];

  loading: boolean = true;
  setValue: boolean = false;

  constructor(
    @Self() public ngCtrl: NgControl,
    private _storeLocSvc: StoreLocationsService,
    private _utilsSvc: UtilitiesService
  ) {
    ngCtrl.valueAccessor = this;
  }

  ngOnInit(): void {
    this.select.nativeElement.value = this.ngCtrl.value ? this.ngCtrl.value : '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.storeRefId) {
      this.getLocations();
    }
  }

  /**
   * Get location options
   */
  getLocations(): void {

    const ctrl = this.ngCtrl.control;
    this.options = [];

    this.loading = true;

    const params = {
      Filter: null
    };

    if (this.storeRefId) {
      params.Filter = `StoreRefId~eq~${this.storeRefId}`  
    }

    this._storeLocSvc.search(params)
      .subscribe((res: any) => {
        this.loading = false;
        this.options = res.Data;
        this.ready.emit();
        if (ctrl.value && this.options.some((val) => val.Id == ctrl.value)) {
          this.setValue = true;
        }
      });

  }

  onSelectChange(value: any) {

    this.onChange(value);

    if (value) {
      const record = this._utilsSvc.getRecordById(this.options, Number(value));
      this.selected.emit(record);
    }

  }

  onChange(_value: any) {}

  onTouched() {}

  writeValue(value: any) {
    this.select.nativeElement.value = value;
  }

  registerOnChange(fn: (value: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  validate(ctrl: AbstractControl) {
    return Validators.required(ctrl);
  }

  ngAfterViewChecked() {
    if(this.setValue){
      this.writeValue(this.ngCtrl.control.value);
      this.setValue = false;
    }
  }

}
